import React from 'react';
import get from 'lodash/get';
import { useDispatch } from 'react-redux';
import Skeleton from 'Common/Components/Skeleton';
import { changeReadOnly } from 'Screens/Contextualization/Workspaces/actions/Actions';
import { Wrapper, LockIcon, UnlockIcon, Text } from './styled';

const LockUnlockWs = ({ isFetching, ws }) => {
  const isWsReadOnly = get(ws, 'readonly', false);
  const name = get(ws, 'name', '');
  const dispatch = useDispatch();

  const toggleReadOnly = (e) => {
    e.stopPropagation();
    dispatch(changeReadOnly(name, !isWsReadOnly));
  };

  if (isFetching) return <Skeleton />;
  return (
    <Wrapper onClick={ toggleReadOnly }>
      {isWsReadOnly
        ? <>
          <LockIcon />
          <Text>Locked</Text>
          </>
        : <>
          <UnlockIcon />
          <Text>Unlocked</Text>
          </>
      }

    </Wrapper>
  );
};

export default LockUnlockWs;
